import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import AzOverviewImpl from './az-overview.js';
import { noop } from 'mojito/utils';

/**
 * The first rendered state in AZMenuView.
 *
 * @class AzOverview
 * @memberof Mojito.Modules
 */

/**
 * Callback used to render a search component instance.
 *
 * @param {boolean} isInitiallyActive - If `true`, the search component should be initially activated, `false` otherwise.
 * @callback Mojito.Modules.AZOverview.renderSearchComponent
 */

/**
 * Callback used to render a search overlay.
 *
 * @param {boolean} isInitiallyActive - If `true`, the search overlay should be initially activated, `false` otherwise.
 * @callback Mojito.Modules.AZOverview.renderSearchOverlay
 */

/**
 * AzOverview prop types.
 *
 * @property {Mojito.Modules.AzOverview.to} [to = ()=>{}] - Navigates to a state specified by the state's name.
 * @property {Mojito.Modules.AzOverview.onClose} [onClose = ()=>{}] - Callback invoked when the state is about to close.
 * @property {Mojito.Modules.AzOverview.renderSearchComponent} [renderSearchComponent = ()=>{}] - Function used to render the search component instance.
 * @property {Mojito.Modules.AzOverview.renderSearchOverlay} [renderSearchOverlay = ()=>{}] -  Function used to render the search overlay instance.
 * @property {boolean} [hideSettings = false] - Flag indicating if the settings link should be hidden.
 * @memberof Mojito.Modules.AzOverview
 */
const propTypes = {
    to: PropTypes.func,
    onClose: PropTypes.func,
    renderSearchComponent: PropTypes.func,
    renderSearchOverlay: PropTypes.func,
    hideSettings: PropTypes.bool,
};

const defaultProps = {
    to: noop,
    onClose: noop,
    renderSearchComponent: noop,
    renderSearchOverlay: noop,
    hideSettings: false,
};

export default MojitoCore.Presentation.UIView(
    'AzOverview',
    AzOverviewImpl,
    propTypes,
    defaultProps
);
